import { CHANGE_FIXED_CONTRIBUTION_PROPS } from "../actions/ActionConstants";

const initialState = {
	fixedContributionsList: [],
	modeCRU: "",
	page: 1,
	total: 0
};

export default function fixedContributionReducer(state = initialState, action) {
	switch (action.type) {
		case CHANGE_FIXED_CONTRIBUTION_PROPS:
			return Object.assign({}, state, action.props);
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/FixedContributionReducer.js